<template>
  <div>
    <wc-data-box
      :title='details.title'
      :titleIcon='details.icon'
      :titleIconColor='details.iconColor'
      showEdit
      @edit='editDetails'
    >
      <wc-two-column-table :items='items'></wc-two-column-table>
      <v-card-text class='pt-0'>
        {{ project.project_detail.lawn_signs_note }}
      </v-card-text>
    </wc-data-box>

    <wc-dialog
      :showDialog='showDialog'
      :title='details.title'
      :icon='details.icon'
      :iconColor='details.iconColor'
      :disableButtons='!isFormValid'
      @cancel='cancelEdit'
      @save='saveEdit'
    >
      <v-form v-model='isFormValid' ref='form'>
        <snow-details-form ref='detailsform' v-model='projectCopy' :project='project'></snow-details-form>
      </v-form>
    </wc-dialog>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import _ from 'lodash'
import SnowDetailsForm from '@/modules/snow/components/forms/SnowDetailsForm'

export default {
  name: 'snow-project-details',
  props: {
    project: {
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    isFormValid: false,
    showDialog: false,
    projectCopy: {}
  }),
  computed: {
    items () {
      let tmp = [
        { text: 'Service start date', value: this.project.start_date ? this.$options.filters.shortDate(this.project.start_date) : 'Not set' },
        { text: 'Service end date', value: this.project.end_date ? this.$options.filters.shortDate(this.project.end_date) : 'Not set' },
        { text: 'Billing Type', value: this.project.project_detail.billing_type === 'M' ? 'Monthly' : 'Annually' },
        // { text: 'Thank you email?', value: this.$options.filters.trueFalse(this.project.project_detail.thank_you_email) },
        { text: 'Renewal Status', value: this.getRenewalText(this.project.project_detail.renewal_status) },
        { text: 'Rock Chip Selected?', value: this.$options.filters.trueFalse(this.project.project_detail.ice_melt_ok) },
        { text: 'Is quickpay?', value: this.$options.filters.trueFalse(this.project.project_detail.is_quickpay) },
        { text: 'Do on Christmas?', value: this.$options.filters.trueFalse(this.project.project_detail.do_on_christmas) },
        { text: 'Lawn sign?', value: this.$options.filters.trueFalse(this.project.project_detail.lawn_signs_ok) },
        { text: 'Lawn signs note:', value: '' }
      ]
      if (this.project.analytics.staging) {
        tmp.unshift({ text: 'Proposed end date (staging)', value: this.$options.filters.shortDate(this.project.analytics.staging.new_end_date) })
        tmp.unshift({ text: 'Proposed start date (staging)', value: this.$options.filters.shortDate(this.project.analytics.staging.new_start_date) })
      }
      return tmp
    },
    ...mapState ({
      details: state => state.icons.dataBox.details,
      billingType: state => state.misc.globalOptions.snowBillingTypes,
      renewalStatus: state => state.misc.globalOptions.snowRenewalStatusOptions
    })
  },
  methods: {
    editDetails () {
      this.projectCopy = _.cloneDeep(this.project)
      this.showDialog = true
    },
    cancelEdit () {
      this.$refs.detailsform.confirmation = null
      this.showDialog = false
    },
    saveEdit () {
      this.$emit('update', this.projectCopy)
      this.cancelEdit()
    },
    getRenewalText(value) {
      if (value) {
        return _.find(this.renewalStatus, r => r.value == value).text
      }
      return "not set"
    }
  },
  components: {
    'snow-details-form': SnowDetailsForm
  }
}
</script>
